module.exports = __webpack_public_path__ + "static/media/history.b963530c.svg";